/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { PostGoogleLogin, PostGoogleCallback } from '@/infrastructure/network/Monitaro/requests/o_auth_google'

export default class OAuthGoogle extends MonitaroGatewayBase {
  async PostGoogleLogin() {
    const { url } = await this.apiClient.request(new PostGoogleLogin())
    return url
  }

  async PostGoogleCallback(params: any) {
    const { result } = await this.apiClient.request(new PostGoogleCallback(params))
    return result
  }
}
